import React, { createContext, useContext } from 'react';
import { usePricing, PricingData } from '../hooks/usePricing';
const CART_LINK = 'https://superlibrodigital.com/cart/56026080411974:1?checkout';
interface PricingContextValue extends PricingData {
  cartLink: string;
  fireAddToCart: () => void;
}
const PricingContext = createContext<PricingContextValue>({
  countryCode: 'US',
  currentPrice: 'US$14.99',
  comparePrice: 'US$47.00',
  currencyCode: 'USD',
  loading: false,
  cartLink: CART_LINK,
  fireAddToCart: () => {}
});
export function PricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const pricing = usePricing();
  function fireAddToCart() {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    } catch (e) {
      // silently fail if pixel not loaded
    }
  }
  return <PricingContext.Provider value={{
    ...pricing,
    cartLink: CART_LINK,
    fireAddToCart
  }} data-id="element-321">
      {children}
    </PricingContext.Provider>;
}
export function usePricingContext() {
  return useContext(PricingContext);
}